import {
  FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_REQUEST,
  FETCH_DJUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_SUCCESS,
  FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_ERROR,
  UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_REQUEST,
  UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_SUCCESS,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    isFetching: false,
  },
  edit: {
    record: {},
    isUpdating: false,
  },
  error: null,
}

const list = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_DJUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
        },
      }

    default:
      return state
  }
}

export default list
